/* KLOKI sales popup — independent name × place × weighted product pools */
const translations = {"cs": "{name} si právě zakoupil/a", "sk": "{name} si práve zakúpil/a", "hu": "{name} éppen megvásárolta", "de": "{name} hat gerade gekauft", "fr": "{name} vient d’acheter", "en": "{name} just bought", "nl": "{name} just bought"};

const popupPools = {
  "cs": {
    "names": [
      "Anna",
      "Barbora",
      "David",
      "Eliška",
      "Filip",
      "Hana",
      "Jakub",
      "Jan",
      "Jana",
      "Kateřina",
      "Kristýna",
      "Lenka",
      "Lucie",
      "Lukáš",
      "Marek",
      "Martin",
      "Michal",
      "Monika",
      "Natálie",
      "Nikola",
      "Ondřej",
      "Petra",
      "Petr",
      "Tereza",
      "Tomáš",
      "Veronika",
      "Adéla",
      "Dominik",
      "Klára",
      "Matěj",
      "Simona",
      "Vojtěch"
    ],
    "places": [
      "z Prahy",
      "z Brna",
      "z Ostravy",
      "z Plzně",
      "z Liberce",
      "z Olomouce",
      "z Českých Budějovic",
      "z Hradce Králové",
      "z Pardubic",
      "z Ústí nad Labem",
      "ze Zlína",
      "z Jihlavy",
      "z Tábora",
      "z Karlových Varů",
      "z Mladé Boleslavi",
      "z Kladna",
      "z Teplic",
      "z Opavy",
      "z Frýdku-Místku",
      "z Havířova",
      "z Prostějova",
      "z Přerova",
      "z Kolína",
      "z Chrudimi"
    ]
  },
  "sk": {
    "names": [
      "Simona",
      "Ján",
      "Martin",
      "Zuzana",
      "Mária",
      "Marek",
      "Lucia",
      "Lenka",
      "Tomáš",
      "Petra",
      "Michal",
      "Katarína",
      "Peter",
      "Veronika",
      "Jakub",
      "Kristína",
      "Filip",
      "Jana",
      "Dominik",
      "Nina",
      "Samuel",
      "Laura",
      "Matej",
      "Natália",
      "Adam",
      "Sofia",
      "Richard",
      "Barbora"
    ],
    "places": [
      "z Bratislavy",
      "z Košíc",
      "z Prešova",
      "z Žiliny",
      "z Banskej Bystrice",
      "z Nitry",
      "z Trnavy",
      "z Trenčína",
      "z Martina",
      "z Popradu",
      "z Prievidze",
      "z Zvolena",
      "z Považskej Bystrice",
      "z Humenného",
      "z Levíc",
      "z Komárna",
      "z Dunajskej Stredy",
      "z Ružomberoka",
      "z Spišskej Novej Vsi",
      "z Michaloviec"
    ]
  },
  "de": {
    "names": [
      "Emma",
      "Laura",
      "Ben",
      "Felix",
      "Anna",
      "Mia",
      "Lukas",
      "Paul",
      "Sophie",
      "Jonas",
      "Lea",
      "Noah",
      "Marie",
      "Tim",
      "Hannah",
      "Leon",
      "Lina",
      "Finn",
      "Julia",
      "Max",
      "Clara",
      "Luis",
      "Nina",
      "Elias",
      "Lisa",
      "David"
    ],
    "places": [
      "aus Berlin",
      "aus München",
      "aus Hamburg",
      "aus Köln",
      "aus Frankfurt",
      "aus Stuttgart",
      "aus Düsseldorf",
      "aus Leipzig",
      "aus Dresden",
      "aus Hannover",
      "aus Nürnberg",
      "aus Bremen",
      "aus Essen",
      "aus Dortmund",
      "aus Mannheim",
      "aus Freiburg",
      "aus Augsburg",
      "aus Karlsruhe",
      "aus Bonn",
      "aus Münster"
    ]
  },
  "fr": {
    "names": [
      "Camille",
      "Jules",
      "Léo",
      "Manon",
      "Lucas",
      "Chloé",
      "Noah",
      "Lina",
      "Louis",
      "Emma",
      "Alice",
      "Gabriel",
      "Zoé",
      "Ethan",
      "Clara",
      "Tom",
      "Léa",
      "Hugo",
      "Inès",
      "Nathan",
      "Sarah",
      "Paul",
      "Jade",
      "Arthur",
      "Louise",
      "Adam"
    ],
    "places": [
      "de Paris",
      "de Lyon",
      "de Marseille",
      "de Toulouse",
      "de Nice",
      "de Nantes",
      "de Strasbourg",
      "de Montpellier",
      "de Bordeaux",
      "de Lille",
      "de Rennes",
      "de Reims",
      "de Toulon",
      "de Grenoble",
      "de Dijon",
      "de Angers",
      "de Nîmes",
      "de Villeurbanne",
      "de Clermont-Ferrand",
      "de Le Havre"
    ]
  },
  "hu": {
    "names": [
      "Levente",
      "Lili",
      "Gergő",
      "Réka",
      "Zsófi",
      "Bence",
      "Eszter",
      "Ádám",
      "Dávid",
      "Anna",
      "Kata",
      "Máté",
      "Noémi",
      "Balázs",
      "Laura",
      "Tamás",
      "Vivien",
      "Petra",
      "Olivér",
      "Nóra",
      "Kristóf",
      "Fanni",
      "Dominik",
      "Sára"
    ],
    "places": [
      "Budapestről",
      "Debrecenből",
      "Szegedről",
      "Miskolcról",
      "Pécsről",
      "Győrből",
      "Nyíregyházáról",
      "Kecskemétről",
      "Székesfehérvárról",
      "Szombathelyről",
      "Szolnokról",
      "Tatabányáról",
      "Kaposvárról",
      "Veszprémből",
      "Békéscsabáról",
      "Zalaegerszegről",
      "Egerből",
      "Sopronból",
      "Nagykanizsáról",
      "Dunaújvárosból"
    ]
  },
  "en": {
    "names": [
      "Olivia",
      "Emily",
      "James",
      "Sophie",
      "Oliver",
      "Amelia",
      "Harry",
      "Isla",
      "George",
      "Mia",
      "Jack",
      "Lily",
      "Charlie",
      "Grace",
      "Thomas",
      "Chloe",
      "William",
      "Emma",
      "Noah",
      "Ava",
      "Leo",
      "Freya",
      "Arthur",
      "Poppy"
    ],
    "places": [
      "from London",
      "from Manchester",
      "from Birmingham",
      "from Leeds",
      "from Glasgow",
      "from Liverpool",
      "from Bristol",
      "from Sheffield",
      "from Edinburgh",
      "from Cardiff",
      "from Nottingham",
      "from Newcastle",
      "from Brighton",
      "from Oxford",
      "from Cambridge",
      "from Reading",
      "from York",
      "from Bath",
      "from Coventry",
      "from Leicester"
    ]
  }
};

const popupProducts = [
  {
    "id": "detske-volaci-gps-hodinky-kloki-star-cerne",
    "weight": 19,
    "image": "https://cdn.shopify.com/s/files/1/0896/0871/6634/files/KLOKI-star-black-1C-gift_f738454e-108e-45d1-82af-94cd2563e2ae.webp?v=1784542990",
    "title": {
      "cs": "KLOKI Star – černé",
      "sk": "KLOKI Star – čierne",
      "de": "KLOKI Star – Schwarz",
      "fr": "KLOKI Star – noire",
      "hu": "KLOKI Star – fekete",
      "en": "KLOKI Star – black"
    },
    "url": {
      "cs": "https://kloki.cz/products/detske-volaci-gps-hodinky-kloki-star-cerne",
      "sk": "https://kloki-shop.sk/products/detske-volacie-gps-hodinky-kloki-star-cierne",
      "de": "https://kloki-shop.de/products/kinder-gps-uhren-kloki-star-schwarz",
      "fr": "https://kloki.fr/products/montres-gps-pour-enfants-kloki-star-noires",
      "hu": "https://kloki.hu/products/gyerek-hivasos-gps-ora-kloki-star-fekete",
      "en": "https://kloki.cz/en/products/kids-calling-gps-watch-kloki-star-black"
    }
  },
  {
    "id": "detske-volaci-gps-hodinky-kloki-star-ruzove",
    "weight": 19,
    "image": "https://cdn.shopify.com/s/files/1/0896/0871/6634/files/KLOKI-star-pink-1C-gift_69ad1c2e-1f23-4618-afa4-0d5fd3b05978.webp?v=1784543102",
    "title": {
      "cs": "KLOKI Star – růžové",
      "sk": "KLOKI Star – ružové",
      "de": "KLOKI Star – Rosa",
      "fr": "KLOKI Star – rose",
      "hu": "KLOKI Star – rózsaszín",
      "en": "KLOKI Star – pink"
    },
    "url": {
      "cs": "https://kloki.cz/products/detske-volaci-gps-hodinky-kloki-star-ruzove",
      "sk": "https://kloki-shop.sk/products/detske-volacie-gps-hodinky-kloki-star-ruzove",
      "de": "https://kloki-shop.de/products/kinder-gps-uhren-kloki-star-rosa",
      "fr": "https://kloki.fr/products/montres-gps-pour-enfants-kloki-star-rose",
      "hu": "https://kloki.hu/products/gyerek-hivo-gps-orak-kloki-star-rozsaszin",
      "en": "https://kloki.cz/en/products/kids-calling-gps-watch-kloki-star-pink"
    }
  },
  {
    "id": "detske-volaci-gps-hodinky-kloki-moon-modre",
    "weight": 15,
    "image": "https://cdn.shopify.com/s/files/1/0896/0871/6634/files/00-KLOKI-Moon-blue.webp?v=1787262661",
    "title": {
      "cs": "KLOKI Moon – modré",
      "sk": "KLOKI Moon – modré",
      "de": "KLOKI Moon – Blau",
      "fr": "KLOKI Moon – bleue",
      "hu": "KLOKI Moon – kék",
      "en": "KLOKI Moon – blue"
    },
    "url": {
      "cs": "https://kloki.cz/products/detske-volaci-gps-hodinky-kloki-moon-modre",
      "sk": "https://kloki-shop.sk/products/detske-volacie-gps-hodinky-kloki-moon-modre",
      "de": "https://kloki-shop.de/products/kinder-anruf-gps-uhren-kloki-moon-blau",
      "fr": "https://kloki.fr/products/enfant-appels-gps-montre-kloki-moon-bleue",
      "hu": "https://kloki.hu/products/gyerek-hivos-gps-ora-kloki-moon-kek",
      "en": "https://kloki.cz/en/products/kids-calling-gps-watch-kloki-moon-blue"
    }
  },
  {
    "id": "detske-volaci-gps-hodinky-kloki-moon-ruzove",
    "weight": 15,
    "image": "https://cdn.shopify.com/s/files/1/0896/0871/6634/files/KLOKI-Moon-1.webp?v=1787212804",
    "title": {
      "cs": "KLOKI Moon – růžové",
      "sk": "KLOKI Moon – ružové",
      "de": "KLOKI Moon – Rosa",
      "fr": "KLOKI Moon – rose",
      "hu": "KLOKI Moon – rózsaszín",
      "en": "KLOKI Moon – pink"
    },
    "url": {
      "cs": "https://kloki.cz/products/detske-volaci-gps-hodinky-kloki-moon-ruzove",
      "sk": "https://kloki-shop.sk/products/detske-volacie-gps-hodinky-kloki-moon-ruzove",
      "de": "https://kloki-shop.de/products/kinder-anruf-gps-uhren-kloki-moon-rosa",
      "fr": "https://kloki.fr/products/enfant-appel-gps-montre-kloki-moon-roses",
      "hu": "https://kloki.hu/products/gyerek-hivo-gps-ora-kloki-moon-rozsaszin",
      "en": "https://kloki.cz/en/products/kids-calling-gps-watch-kloki-moon-pink"
    }
  },
  {
    "id": "dokovaci-stanice-kloki-star-zakladna-pro-novou-energii",
    "weight": 6,
    "image": "https://cdn.shopify.com/s/files/1/0896/0871/6634/files/Dock-kloki-star.png?v=1760088778",
    "title": {
      "cs": "Dokovací stanice KLOKI Star",
      "sk": "Dokovacia stanica KLOKI Star",
      "de": "Ladestation KLOKI Star",
      "fr": "Station de recharge KLOKI Star",
      "hu": "KLOKI Star töltődokkoló",
      "en": "KLOKI Star charging dock"
    },
    "url": {
      "cs": "https://kloki.cz/products/dokovaci-stanice-kloki-star-zakladna-pro-novou-energii",
      "sk": "https://kloki-shop.sk/products/dokovacia-stanica-kloki-star-zakladna-pre-novu-energii",
      "de": "https://kloki-shop.de/products/dockstation-kloki-star-basis-fur-neue-energie",
      "fr": "https://kloki.fr/products/station-daccueil-kloki-star-base-pour-nouvelle-energie",
      "hu": "https://kloki.hu/products/dokkoloallomas-kloki-csillag-alap-uj-energiahoz",
      "en": "https://kloki.cz/en/products/dokovaci-stanice-kloki-star-base-for-new-energy"
    }
  },
  {
    "id": "ochranne-plexisklo-pro-hodinky-kloki-star",
    "weight": 6,
    "image": "https://cdn.shopify.com/s/files/1/0896/0871/6634/files/kloki_ochranne_sklo_1.webp?v=1763040152",
    "title": {
      "cs": "Ochranné sklo KLOKI Star",
      "sk": "Ochranné sklo KLOKI Star",
      "de": "Schutzglas KLOKI Star",
      "fr": "Verre de protection KLOKI Star",
      "hu": "Védőüveg KLOKI Star",
      "en": "Screen protector KLOKI Star"
    },
    "url": {
      "cs": "https://kloki.cz/products/ochranne-plexisklo-pro-hodinky-kloki-star",
      "sk": "https://kloki-shop.sk/products/ochranne-plexisklo-pre-hodinky-kloki-star",
      "de": "https://kloki-shop.de/products/schutz-plexiglas-fur-kloki-star-uhren",
      "fr": "https://kloki.fr/products/verre-plexi-protecteur-pour-montres-kloki-star",
      "hu": "https://kloki.hu/products/vedo-plexi-ora-kloki-star",
      "en": "https://kloki.cz/en/products/ochranne-plexiglass-for-kloki-star-watches"
    }
  },
  {
    "id": "nahradni-gumovy-reminek-na-hodinky",
    "weight": 6,
    "image": "https://cdn.shopify.com/s/files/1/0896/0871/6634/files/Nahradni_reminek_na_detske_hodinky_KLOKI_modry-predni-cast.png?v=1753691904",
    "title": {
      "cs": "Gumový řemínek",
      "sk": "Gumový remienok",
      "de": "Gummi-Armband",
      "fr": "Bracelet en caoutchouc",
      "hu": "Gumiszíj",
      "en": "Rubber strap"
    },
    "url": {
      "cs": "https://kloki.cz/products/nahradni-gumovy-reminek-na-hodinky",
      "sk": "https://kloki-shop.sk/products/nahradny-gumovy-remienok-na-hodinky",
      "de": "https://kloki-shop.de/products/ersatz-gummi-armband-fuer-uhr",
      "fr": "https://kloki.fr/products/bracelet-de-montre-en-caoutchouc-de-rechange",
      "hu": "https://kloki.hu/products/csere-gumi-szij-orahoz",
      "en": "https://kloki.cz/en/products/replacement-rubber-strap-for-watches"
    }
  },
  {
    "id": "reminek-na-suchy-zip-pro-kloki-hodinky",
    "weight": 5,
    "image": "https://cdn.shopify.com/s/files/1/0896/0871/6634/files/Reminky-suchy.png?v=1762332364",
    "title": {
      "cs": "Řemínek na suchý zip",
      "sk": "Remienok na suchý zips",
      "de": "Klettarmband",
      "fr": "Bracelet à scratch",
      "hu": "Tépőzáras szíj",
      "en": "Velcro strap"
    },
    "url": {
      "cs": "https://kloki.cz/products/reminek-na-suchy-zip-pro-kloki-hodinky",
      "sk": "https://kloki-shop.sk/products/remienok-na-suchy-zips-pre-kloki-hodinky",
      "de": "https://kloki-shop.de/products/klettverschluss-armband-fur-kloki-uhr",
      "fr": "https://kloki.fr/products/bracelet-a-scratch-pour-montre-kloki",
      "hu": "https://kloki.hu/products/szij-tepozarral-kloki-orakhoz",
      "en": "https://kloki.cz/en/products/reminder-for-dry-zip-for-klocki-watches"
    }
  },
  {
    "id": "silikonovy-reminek-s-hravym-dotty-motivem",
    "weight": 5,
    "image": "https://cdn.shopify.com/s/files/1/0896/0871/6634/files/black-band-blue-spots.png?v=1760097026",
    "title": {
      "cs": "Silikonový řemínek Dotty",
      "sk": "Silikónový remienok Dotty",
      "de": "Silikonarmband Dotty",
      "fr": "Bracelet silicone Dotty",
      "hu": "Szilikon szíj Dotty",
      "en": "Silicone strap Dotty"
    },
    "url": {
      "cs": "https://kloki.cz/products/silikonovy-reminek-s-hravym-dotty-motivem",
      "sk": "https://kloki-shop.sk/products/silikonovy-remienok-s-hravym-dotty-motivom",
      "de": "https://kloki-shop.de/products/silikonarmband-mit-verspieltem-punkte-motiv",
      "fr": "https://kloki.fr/products/bracelet-en-silicone-avec-motif-ludique-points",
      "hu": "https://kloki.hu/products/silikon-szij-jatekos-pottyos-mintaval",
      "en": "https://kloki.cz/en/products/silikonovy-strap-with-playful-dotty-pattern"
    }
  },
  {
    "id": "silikonovy-reminek-s-hravym-kloki-motivem",
    "weight": 4,
    "image": "https://cdn.shopify.com/s/files/1/0896/0871/6634/files/reminek_star_KLOKI_1.webp?v=1760009974",
    "title": {
      "cs": "Silikonový řemínek KLOKI",
      "sk": "Silikónový remienok KLOKI",
      "de": "Silikonarmband KLOKI",
      "fr": "Bracelet silicone KLOKI",
      "hu": "Szilikon szíj KLOKI",
      "en": "Silicone strap KLOKI"
    },
    "url": {
      "cs": "https://kloki.cz/products/silikonovy-reminek-s-hravym-kloki-motivem",
      "sk": "https://kloki-shop.sk/products/silikonovy-remienok-s-hravym-klokanim-motivom",
      "de": "https://kloki-shop.de/products/silikonarmband-mit-verspieltem-klokki-motiv",
      "fr": "https://kloki.fr/products/sangle-en-silicone-avec-motif-de-clochette-ludique",
      "hu": "https://kloki.hu/products/silikon-szij-jatekos-kacsa-mintaval",
      "en": "https://kloki.cz/en/products/silikonovy-strap-with-playful-bunny-motif"
    }
  }
];

// JAZYK VĚTY se řídí jazykem stránky (šablona textu, „si právě zakoupil/a“,
// název produktu) — tady se nic nemění.
const lang = (document.documentElement.lang || 'cs').slice(0, 2);
const activeLang = (lang === 'nl') ? 'en' : (popupPools[lang] ? lang : 'cs');
const t = translations[activeLang] || translations.cs;

// JMÉNO A MĚSTO se naopak řídí TRHEM, ne jazykem stránky. Do 16. 9. 2026 se
// podle jazyka vybíralo obojí, takže kloki.cz/en (český trh, ceny v korunách)
// hlásil britská jména a Londýn, a kloki-shop.de/en zase taky — tedy kupujícího
// odjinud, než kde zákazník právě nakupuje.
const TRH_POOL = { CZ: 'cs', SK: 'sk', DE: 'de', FR: 'fr', HU: 'hu' };
const TRH_POOL_NEUTRAL = 'en';
const DOMENA_TRH = {
  'kloki.cz': 'CZ',
  'kloki-shop.sk': 'SK',
  'kloki-shop.de': 'DE',
  'kloki.fr': 'FR',
  'kloki.hu': 'HU'
};

// Vrátí jazyk poolu podle trhu, nebo prázdný řetězec, když se trh určit nedá —
// a v tom případě zůstane dnešní chování (pool podle jazyka stránky).
function trhPoolLang() {
  // 1) Shopify.country vydává server v content_for_header a drží se TRHU,
  //    ne jazyka stránky (ověřeno 16. 9. 2026 na všech pěti doménách:
  //    kloki.cz/en = CZ, kloki-shop.de/en = DE, kloki-shop.sk/cs = SK).
  //    Shopify.currency.active se použít NEDÁ — EUR mají SK, DE i FR naráz.
  var zeme = '';
  try {
    if (window.Shopify && typeof window.Shopify.country === 'string') {
      zeme = window.Shopify.country.trim().toUpperCase();
    }
  } catch (e) {}
  if (TRH_POOL[zeme]) return TRH_POOL[zeme];

  // 2) Doména. Chytá případ, kdy trh pokrývá víc zemí a Shopify.country tedy
  //    vrátí zemi kupujícího (Rakušan na kloki-shop.de dostane "AT") — bez
  //    tohoto kroku by místo německého poolu spadl na neutrální.
  var host = '';
  try {
    host = ((window.location && window.location.hostname) || '').toLowerCase();
  } catch (e) {}
  if (host.indexOf('www.') === 0) host = host.slice(4);
  if (DOMENA_TRH[host]) return TRH_POOL[DOMENA_TRH[host]];

  // 3) Trh známe, ale není to žádný z našich pěti (mezinárodní) → neutrální.
  if (zeme) return TRH_POOL_NEUTRAL;

  // 4) Trh se určit nepodařilo → fail-open na dnešní chování.
  return '';
}

const trhLang = trhPoolLang();
const poolLang = (trhLang && popupPools[trhLang]) ? trhLang : activeLang;
const pool = popupPools[poolLang];

const popup = document.getElementById('kloki-sales-popup');
if (popup && pool) {
  const nameEl = popup.querySelector('.kloki-popup-name-location strong');
  const productEl = popup.querySelector('.kloki-popup-product-link');
  const imageEl = popup.querySelector('.kloki-popup-image');
  const imageLink = popup.querySelector('.kloki-popup-image-link');
  const starsEl = popup.querySelector('.kloki-popup-stars');
  const closeEl = popup.querySelector('.kloki-popup-close');

  const productWeightTotal = popupProducts.reduce((sum, p) => sum + p.weight, 0);
  let lastKey = '';

  function pick(list) {
    return list[Math.floor(Math.random() * list.length)];
  }

  function pickWeightedProduct() {
    let r = Math.random() * productWeightTotal;
    for (const p of popupProducts) {
      r -= p.weight;
      if (r <= 0) return p;
    }
    return popupProducts[popupProducts.length - 1];
  }

  // Adresu produktu skládáme z kořene obchodu a ČESKÉHO handlu (pole id).
  // Shopify přeložený handle dosadí samo — ověřeno 14. 9. 2026: český handle
  // vrací na kloki-shop.de i kloki.hu HTTP 301 na přeloženou adresu a na
  // cestách /cs rovnou 200. Mapy product.url zůstávají v datech nepoužité:
  // měly adresy natvrdo podle JAZYKA, takže z kloki-shop.de/en odváděly
  // zákazníka na kloki.cz — tedy na jiný trh s jinou měnou.
  function klokiOdkaz(handle) {
    var koren = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '';
    if (!koren && window.routes && window.routes.cart_url) {
      koren = window.routes.cart_url.replace(/\/cart\/?$/, '') + '/';
    }
    if (!koren) koren = '/';
    if (koren.charAt(koren.length - 1) !== '/') koren += '/';
    return koren + 'products/' + handle;
  }

  function nextSale() {
    let name, place, product, key;
    for (let i = 0; i < 12; i++) {
      name = pick(pool.names);
      place = pick(pool.places);
      product = pickWeightedProduct();
      key = name + '|' + place + '|' + product.id;
      if (key !== lastKey) break;
    }
    lastKey = key;
    return {
      name: name + ' ' + place,
      product: product.title[activeLang] || product.title.cs,
      image: product.image,
      url: klokiOdkaz(product.id)
    };
  }

  // Timing (ms): first after browse-in, short flash, gap ~once per 80s.
  const POPUP_FIRST_DELAY_MS = 50000;
  const POPUP_VISIBLE_MS = 5000;
  const POPUP_GAP_MS = 80000;

  function showPopup() {
    const data = nextSale();
    nameEl.textContent = t.replace('{name}', data.name);
    productEl.textContent = data.product;
    productEl.href = data.url;
    imageEl.src = data.image;
    imageLink.href = data.url;
    starsEl.textContent = '★★★★★';

    // Lepicí lišta produktu sedí u spodní hrany (position:fixed; bottom:0)
    // a okno by jí zakrylo tlačítko do košíku — naměřeno 14. 9. 2026 na
    // 375x812 px překryv 154x36 px, tedy 89 % plochy tlačítka. Výšku lišty
    // čteme až tady: liší se podle produktu i podle toho, jestli běží akce.
    var listaAtc = document.querySelector('.sticky-atc.is-visible');
    popup.style.bottom = listaAtc ? (listaAtc.offsetHeight + 12) + 'px' : '';

    popup.classList.remove('hidden');
    popup.classList.add('show');

    setTimeout(() => {
      popup.classList.remove('show');
      popup.classList.add('hidden');
    }, POPUP_VISIBLE_MS);
  }

  function loopPopup() {
    showPopup();
    setTimeout(loopPopup, POPUP_GAP_MS);
  }

  if (closeEl) {
    closeEl.addEventListener('click', () => {
      popup.classList.remove('show');
      popup.classList.add('hidden');
    });
  }

  setTimeout(loopPopup, POPUP_FIRST_DELAY_MS);
}
